import { getBrightcoveVideoUrl } from "@constants/common";

type VideoContent = {
	id: number;
	title: string;
	description: string;
	type: string;
	imageUri: string;
	videoUri: string;
};

export const tagIconUrlMap: Record<string, string> = {
	Ethics:
		"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/ethics.png",
	"Pathology & Basic Science":
		"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/pathology.png",
	"Adult Knee Reconstruction":
		"https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/adult-knee.png",
	"Pain Management":
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Pain_Management%20Background%20Removed.png?t=2024-12-04T04%3A56%3A07.527Z",
	Pediatrics:
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Pediatrics%20Background%20Removed.png?t=2024-12-04T04%3A56%3A22.695Z",
	"Hand & Wrist":
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Hand_And_Wrist%20Background%20Removed.png?t=2024-12-04T04%3A56%3A32.709Z",
	"Foot & Ankle":
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Foot_And_Ankle%20Background%20Removed.png?t=2024-12-04T04%3A56%3A40.944Z",
	Oncology:
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Oncology%20Background%20Removed.png?t=2024-12-04T04%3A56%3A52.746Z",
	Hip: "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Hip%20Background%20Removed.png?t=2024-12-04T04%3A57%3A03.820Z",
	Infection:
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Infection%20Background%20Removed.png?t=2024-12-04T04%3A57%3A18.595Z",
	Spine:
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Spine%20Background%20Removed.png?t=2024-12-04T04%3A57%3A27.049Z",
	Trauma:
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Trauma%20Background%20Removed.png?t=2024-12-04T04%3A57%3A36.597Z",
	"Shoulder & Elbow":
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Shoulder_And_Elbow%20Background%20Removed.png?t=2024-12-04T04%3A57%3A44.448Z",
	Knee: "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Knee%20Background%20Removed.png?t=2024-12-04T04%3A57%3A52.598Z",
	"Sports Medicine":
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Sports_Medicine%20Background%20Removed.png?t=2024-12-04T04%3A58%3A02.680Z",
	"Basic Science":
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Basic_Science%20Background%20Removed.png",
	"Orthopaedic Essentials":
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Orthopedic_Essentials%20Background%20Removed.png?t=2024-12-04T04%3A58%3A20.301Z",
	"Education & Training":
		"https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/onboardings/specialites_removed_bg_mac/Education_And_Training%20Background%20Removed%20Background%20Removed.png?t=2024-12-04T04%3A58%3A31.424Z",
};

const getMockedVideo = (
	video: Omit<VideoContent, "type" | "imageUri" | "videoUri">,
) => ({
	...video,
	type: "video",
	imageUri: "",
	videoUri: getBrightcoveVideoUrl(video.id),
});

export const mockedVideos = [
	{
		title: "Revision Risk Calculator",
		data: [
			[
				getMockedVideo({
					id: 6225652219001,
					title: "Revision Risk Calculator",
					description:
						"Demonstration of how the Revision Risk Calculator can be used in the clinic setting to estimate the patient-specific risk of a subsequent revision surgical procedure following ACL reconstruction.",
				}),
			],
		],
	},
	{
		title: "ACL surgery after primary double-bundle ACL reconstruction",
		data: [
			[
				getMockedVideo({
					id: 3118375623001,
					title: "Revision ACL Surgery",
					description:
						"Video demonstrating revision ACL surgery after primary double-bundle ACL reconstruction. AM = anteromedial, PL = posterolateral, AP = anteroposterior, and PA = posteroanterior.",
				}),
			],
		],
	},
	{
		title: "Constructing an Osseointegrated Prosthetic Leg",
		data: [
			[
				getMockedVideo({
					id: 6338403713112,
					title: "Introduction, references, background, overview",
					description: "Video 1",
				}),
				getMockedVideo({
					id: 6332749920112,
					title: "Key steps of the surgery",
					description: "Video 2",
				}),
				getMockedVideo({
					id: 6332748261112,
					title: "Step 1 team evaluation",
					description: "Video 3",
				}),
				getMockedVideo({
					id: 6332749253112,
					title: "Step 2 implant inspection",
					description: "Video 4",
				}),
				getMockedVideo({
					id: 6332747972112,
					title: "Step 3 temporary prosthesis",
					description: "Video 5",
				}),
				getMockedVideo({
					id: 6332748752112,
					title: "Step 4 quality check",
					description: "Video 6",
				}),
				getMockedVideo({
					id: 6332748466112,
					title: "Step 5 bench alignment",
					description: "Video 7",
				}),
				getMockedVideo({
					id: 6332749374112,
					title: "Step 6 static alignment",
					description: "Video 8",
				}),
				getMockedVideo({
					id: 6332750815112,
					title: "Step 7 initial dynamic alignment",
					description: "Video 9",
				}),
				getMockedVideo({
					id: 6332750723112,
					title: "Step 8 continued care",
					description: "Video 10",
				}),
				getMockedVideo({
					id: 6332749566112,
					title: "Risks",
					description: "Video 11",
				}),
				getMockedVideo({
					id: 6338402638112,
					title: "Outcomes",
					description: "Video 12",
				}),
				getMockedVideo({
					id: 6332749657112,
					title: "Conclusions, pearls, and pitfalls",
					description: "Video 13",
				}),
				getMockedVideo({
					id: 6332750731112,
					title: "References",
					description: "Video 14",
				}),
			],
		],
	},
	{
		title: "TERT for patellar instability",
		data: [
			[
				getMockedVideo({
					id: 6254202494001,
					title: "TERT for patellar instability",
					description:
						"The TERT for patellar instability. The video provides an explanation of the test and demonstrates a positive test in 8 patients.",
				}),
			],
		],
	},
	{
		title: "Open Excision of Dorsal Wrist Ganglion",
		data: [
			[
				getMockedVideo({
					id: 6317560222112,
					title: "Introduction and background",
					description: "Video 1",
				}),
				getMockedVideo({
					id: 6317560525112,
					title: "Overview of procedure",
					description: "Video 2",
				}),
				getMockedVideo({
					id: 6317558568112,
					title: "Planning, positioning, and exposure",
					description: "Video 3",
				}),
				getMockedVideo({
					id: 6317561124112,
					title: "Incision",
					description: "Video 4",
				}),
				getMockedVideo({
					id: 6317561864112,
					title: "Deep dissection",
					description: "Video 5",
				}),
				getMockedVideo({
					id: 6317560199112,
					title: "Cyst visualization",
					description: "Video 6",
				}),
				getMockedVideo({
					id: 6317559994112,
					title: "Cyst removal",
					description: "Video 7",
				}),
				getMockedVideo({
					id: 6317562472112,
					title: "Inspection of joint",
					description: "Video 8",
				}),
				getMockedVideo({
					id: 6317561595112,
					title: "Closure",
					description: "Video 9",
				}),
				getMockedVideo({
					id: 6317563665112,
					title: "Results and conclusions",
					description: "Video 10",
				}),
			],
		],
	},
];
